import React from 'react';
import logo from './assets/ia_logo.png';

const NonKioskApp = () => {
    return (
        <div className="non-kiosk-app" >
            <div className="logo">
                <img src={logo} alt='IA Logo' />
            </div>
            <h1>
                This app has to run as a kiosk app.
            </h1>
            <p>
                Please enable it as a kiosk application, log out and start it.
            </p>
            <hr />
            <h1>
                Måste köras som en kiosk app.
            </h1>
            <p>
                Var snäll at aktivera som kiosk app, logga ut och starta den.
            </p>
            <hr />
            <h1>
                Må kjøres som en kiosk app
            </h1>
            <p>
                Vennligst aktiver den som en kiosk app, logg ut og start den.
            </p>
        </div>


    )
}

export default NonKioskApp;